import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { publish } from 'rxjs/operators';

@Component({
  selector: 'app-dependent-eventlog-dialog',
  template: require('./dependent-eventlog-dialog.component.html'),
  styles: [require('./dependent-eventlog-dialog.component.css')],
})
export class DependentEventlogDialogComponent implements OnInit {
    message;
    eventLogs = [];
    request;
    response;
    log = {}
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DependentEventlogDialogComponent>
    ) {
        this.eventLogs = data.eventLogs;
        this.eventLogs.forEach(item => {
            let message = item.message.split("\n");
            //item.request = JSON.parse(message[1].slice(message[1].indexOf("{")));
            //try {
            //    item.response = JSON.parse(message[2].slice(message[2].indexOf("{")));
            //} catch{
            //    item.response = message[2];
            //}
        });
        console.log(this.eventLogs);
        /*this.request = JSON.parse(this.eventLogs[1].slice(this.eventLogs[1].indexOf("{")));
        this.response = JSON.parse(JSON.parse(this.eventLogs[2].replace('\\\"', '\\"').slice(this.eventLogs[2].indexOf("{") - 1)));
        this.log = {
            createdDate: data.eventLogs.createdTime,
            request: this.request,
            response: this.response
        }
        this.message = this.eventLogs[2];
        console.log(this.request,this.response)*/
    }

    ngOnInit() {
      
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/members/dependent-eventlog-dialog/dependent-eventlog-dialog.component.ts